// HorizontalBarChart.js
import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { ResultContext } from '../../contexts/ResultContext';
import { useTheme } from '../../contexts/ThemeContext';

const HorizontalBarChart = () => {

    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const axisColor = isDark ? '#ccc' : '#333';

    const { result } = useContext(ResultContext);
    const [data, setData] = useState();
    const url = result?.results?.visualization_data_jsons['1_empty_value_distribution'];

    useEffect(() => {

        readFileFromPresignedUrl(url).then(content => {
            // Do something with content
            console.log(content);
            setData(content)
        });
    }, [url]);

    const readFileFromPresignedUrl = async (url) => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Failed to fetch file");

            const text = await response.json(); // or response.text() if it's JSON
            console.log("File content:", text);
            return text;
        } catch (error) {
            console.error("Error reading file:", error);
            return null;
        }
    };

    if (!data || !Array.isArray(data) || data.length === 0) {
        return <div>Loading chart...</div>; // or null
    }
    const option = {
        title: {
            text: 'Percentage of Empty Fields',
            left: 'center',
            textStyle: { color: axisColor },
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            formatter: ({ 0: { name, value } }) => `${name}: ${value}%`,
        },
        grid: {
            left: '5%',
            right: '10%',
            bottom: '5%',
            top: '15%',
            containLabel: true,
        },
        xAxis: {
            type: 'value',
            axisLabel: {
                color: axisColor,
                formatter: '{value}%',
            },
        },
        yAxis: {
            type: 'category',
            data: data?.map(item => item.Column),
            inverse: true,
            axisLabel: {
                color: axisColor,
            }
        },
        series: [
            {
                name: 'Percentage Empty',
                type: 'bar',
                data: data?.map(item => item.Percentage_Empty),
                itemStyle: {
                    color: '#4f46e5',
                },
                label: {
                    show: true,
                    position: 'right',
                    formatter: '{c}%',
                    textStyle: { color: axisColor },
                },
            },
        ],
    };


    return <div className="border-2 border-gray-300 rounded-lg p-4">
        <ReactECharts option={option} style={{ height: 500, width: '100%' }} />
    </div>;
};

export default HorizontalBarChart;
